// ============================================================================
// WAEC Mathematics — Learn Content — SS2
// ============================================================================

export const WAEC_MATHEMATICS_LEARN_SS2 = [
  {
    topic: 'Quadratic Equations & Polynomials',
    content: 'Standard form: ax² + bx + c = 0 (a ≠ 0). Three solution methods: (1) **Factorisation** — find two numbers that multiply to ac and add to b. (2) **Quadratic formula** — x = (−b ± √(b²−4ac)) / 2a. (3) **Completing the square** — rearrange to (x+p)² = q form. The **discriminant** b²−4ac tells you the nature of roots: >0 means two distinct real roots, =0 means one repeated root, <0 means no real roots. Sum of roots = −b/a; product of roots = c/a.',
  },
  {
    topic: 'Mensuration — Areas & Volumes',
    content: '2D formulas: Circle area = πr², circumference = 2πr. Triangle area = ½ × base × height. Trapezium area = ½(a+b)×h. 3D formulas: Cylinder volume = πr²h, surface area = 2πr(r+h). Cone volume = ⅓πr²h, slant height l = √(r²+h²). Sphere volume = ⁴⁄₃πr³, surface area = 4πr². Prism volume = cross-section area × length. Always write the formula first, substitute, then calculate to earn method marks even if the final answer is wrong.',
  },
];
